import React, { useEffect, useState, useRef } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import UpdateActivity from "./update-activity";
import ActivitySideList from "./components/activity-side-list";
import BookingDetails from "./components/booking-details";
import Logs from "./components/logs";
import DocumentFiles from "./components/documents-files";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { getAllActivities } from "../../redux/actions/performance";
import { RESET_PERFORMANCE_STATE, SET_PERFORMANCE_HEADER_DATA } from "../../redux/constants";

const ActivityPerformance = (props) => {
  const dispatch = useDispatch();
  const [activitydata, setActivityData] = useState([]);
  const [newjson, setNewJson] = useState([]);
  const [openTab, setOpenTab] = useState(1);
  const [fileNames, setFileNames] = useState([]);
  const [activityPerformance, setActivityPerformance] = useState({});
  const [performancevalue, setPerformanceValue] = useState([]);
  const [activityperformed, setActivityPerformed] = useState(false);
  const [showactivity, setShowActivity] = useState(false);
  const [obj, setObj] = useState({});

  // Creating state for mobile view
  const [isMobileView, setIsMobileView] = useState(false);
  const [userinfo, setUserInfo] = useState([]);

  const { activity_assignment_id } = useParams();
  const [searchParams] = useSearchParams();
  const [editstate, setEditState] = useState(false);
  const [renderdata, setRenderData] = useState(false);
  // const [activitystatus, setActivityStatus] = useState(false);
  const [selectActivityId, setSelectedActivityID] = useState("");
  const [loader, setLoader] = useState(false);

  // Creating state to store activity name
  const [activityName, setActivityName] = useState();

  // Reloading activity performance
  const [updatePerformanceTable, setUpdatePerformanceTable] = useState(0);

  // File List for Activity
  const [userdept, setUserDept] = useState("");
  const [compulsoryactivity, setCompulsoryActivity] = useState("");

  // Redux
  const { activities, jobId } = useSelector((state) => state.performance);

  useEffect(() => {
    if (searchParams.get("activity_id")) {
      setSelectedActivityID(searchParams.get("activity_id"));
    }
  }, []);

  useEffect(() => {
    setLoader(true);
    dispatch(
      getAllActivities(activity_assignment_id, (res) => {
        setLoader(false);
      })
    );
    return () => {
      dispatch({type: RESET_PERFORMANCE_STATE})
    }
  }, [activity_assignment_id, dispatch, updatePerformanceTable]);

  // Creating ref for custome height
  const contentHeightRef = useRef(null);
  const sliderRef = useRef(null);

  useEffect(() => {
    dispatch({
      type: SET_PERFORMANCE_HEADER_DATA,
      payload: {
        jobId,
        activityName,
      },
    });
  }, [jobId, activityName]);

  useEffect(() => {
    if (activities.length !== 0) {
      activities.forEach((item) => {
        if (
          item.can_perform &&
          item.is_mandatory &&
          item.status === "pending"
        ) {
          setCompulsoryActivity(item.activity.name);
        }
      });
    }
  }, [activities]);

  return (
    <div className="min-h-full bg-white sm:mx-6 lg:mx-8">
      {loader ? (
        <div className="h-[90vh] flex justify-center items-center">
          <div class="px-6">
            <svg
              className="animate-spin w-12 h-12 fill-current shrink-0"
              viewBox="0 0 16 16"
            >
              <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
            </svg>
          </div>
        </div>
      ) : (
        <div className="w-full block sm:flex">
          <div className="w-full sm:w-1/4">
            <ActivitySideList
              activitydata={activitydata}
              setActivityData={setActivityData}
              newjson={newjson}
              setNewJson={setNewJson}
              setOpenTab={setOpenTab}
              activityPerformance={activityPerformance}
              setActivityPerformance={setActivityPerformance}
              setFileNames={setFileNames}
              activityperformed={activityperformed}
              setActivityPerformed={setActivityPerformed}
              setPerformanceValue={setPerformanceValue}
              activity_assignment_id={activity_assignment_id}
              setShowActivity={setShowActivity}
              setObj={setObj}
              setIsMobileView={setIsMobileView}
              isMobileView={isMobileView}
              setUserInfo={setUserInfo}
              setEditState={setEditState}
              setRenderData={setRenderData}
              selectActivityId={selectActivityId}
              setSelectedActivityID={setSelectedActivityID}
              contentHeightRef={contentHeightRef}
              sliderRef={sliderRef}
              setActivityName={setActivityName}
              setUserDept={setUserDept}
            />
          </div>

          <div
            className={`${
              isMobileView ? "block" : "hidden"
            }bg-gray-50 w-full sm:block sm:w-3/4 min-h-100`}
          >
            <div
              className={`${isMobileView ? "block" : "hidden"} sm:hidden pt-2`}
            >
              <button
                className="btn bg-white border-slate-200"
                onClick={(e) => setIsMobileView(false)}
              >
                &lt;- Back
              </button>
            </div>
            {/* Tabs */}
            <div
              className={`${
                isMobileView ? "block" : "hidden"
              } sm:block sm:pt-1 sm:px-5`}
              ref={contentHeightRef}
            >
              <ul
                className="relative text-sm font-medium flex flex-nowrap overflow-x-scroll no-scrollbar"
                id="tabs-tabJustify"
                role="tablist"
              >
                <li className="flex-grow text-center">
                  <a
                    href="#tabAdded"
                    className={
                      "w-full block font-medium leading-5 whitespace-nowrap text-xs sm:text-sm border-x-0 border-t-0 border-b-2 px-6 py-4 my-3" +
                      (openTab === 1
                        ? "border-b-2 border-[--bg-color-500] text-black"
                        : null)
                    }
                    id="tab-added"
                    data-toggle="tab"
                    role="tablist"
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenTab(1);
                    }}
                  >
                    To Do Performance
                  </a>
                </li>
                <li className="nav-item flex-grow text-center">
                  <a
                    href="#tabNotadded"
                    className={
                      "w-full block font-medium leading-5 whitespace-nowrap text-xs sm:text-sm border-x-0 border-b-2 border-t-0 px-6 py-4 my-3" +
                      (openTab === 2
                        ? "border-b-2 border-[--bg-color-500] text-black"
                        : null)
                    }
                    id="tab-added"
                    data-toggle="tab"
                    role="tablist"
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenTab(2);
                    }}
                  >
                    Booking Details
                  </a>
                </li>
                <li className="flex-grow text-center">
                  <a
                    href="#tabNotadded"
                    className={
                      "w-full block font-medium leading-5 text-xs sm:text-sm whitespace-nowrap border-x-0 border-b-2 border-t-0 px-6 py-4 my-3" +
                      (openTab === 3
                        ? "border-b-2 border-[--bg-color-500] text-black"
                        : null)
                    }
                    id="tab-added"
                    data-toggle="tab"
                    role="tablist"
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenTab(3);
                    }}
                  >
                    Analytics
                  </a>
                </li>
                <li className="nav-item flex-grow text-center">
                  <a
                    href="#tabNotadded"
                    className={
                      "w-full block font-medium leading-5 whitespace-nowrap text-xs sm:text-sm border-x-0 border-b-2 border-t-0 px-6 py-4 my-3" +
                      (openTab === 4
                        ? "border-b-2 border-[--bg-color-500] text-black"
                        : null)
                    }
                    id="tab-added"
                    data-toggle="tab"
                    role="tablist"
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenTab(4);
                    }}
                  >
                    Document Files
                  </a>
                </li>
              </ul>

              <UpdateActivity
                openTab={openTab}
                activitydata={activitydata}
                newjson={newjson}
                setNewJson={setNewJson}
                activityPerformance={activityPerformance}
                setActivityPerformance={setActivityPerformance}
                fileNames={fileNames}
                setFileNames={setFileNames}
                activityperformed={activityperformed}
                setActivityPerformed={setActivityPerformed}
                performancevalue={performancevalue}
                setPerformanceValue={setPerformanceValue}
                showactivity={showactivity}
                obj={obj}
                userinfo={userinfo}
                activity_assignment_id={activity_assignment_id}
                setUserInfo={setUserInfo}
                editstate={editstate}
                setEditState={setEditState}
                renderdata={renderdata}
                setRenderData={setRenderData}
                updatePerformanceTable={updatePerformanceTable}
                setUpdatePerformanceTable={setUpdatePerformanceTable}
                sliderRef={sliderRef}
                activityName={activityName}
                setOpenTab={setOpenTab}
                userdept={userdept}
                compulsoryactivity={compulsoryactivity}
              />
              <BookingDetails openTab={openTab} />
              <Logs openTab={openTab} activitydata={activitydata} />
              <DocumentFiles
                openTab={openTab}
                activity_assignment_id={activity_assignment_id}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

ActivityPerformance.auth = {
  path: "/activity/performance/:activity_assignment_id",
  role: "ALL",
};
export default ActivityPerformance;
